import {
  CContainer,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import { useEffect, useState } from "react";
import Errors from "../../models/errors";
import UserChangePasswordForm from "./UserChangePasswordForm";
import CompanyUser, { newCompanyUser } from "../../models/company-user";

interface UserUpdateModalProps {
  show: boolean;
  user?: CompanyUser;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const UserChangePasswordModal: React.FC<UserUpdateModalProps> = ({
  show,
  user,
  onCancel,
  onSuccess,
}) => {
  const [initialErrors, setInitialErrors] = useState<Errors>({});
  const [initialUser, setInitialUser] = useState<CompanyUser>(
    user ? user : newCompanyUser()
  );

  const modalTitle = user
    ? `Cambiar contraseña de usuario: ${user.email}`
    : "Cambiar contraseña";

  const onClose = () => {
    setInitialErrors({});
    setInitialUser(newCompanyUser());
    onCancel();
  };

  useEffect(() => {
    setInitialUser(user ? user : newCompanyUser());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  return (
    <CModal show={show} onClose={onClose} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>{modalTitle}</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <UserChangePasswordForm
            initialUser={initialUser}
            initialErrors={initialErrors}
            onCancel={onCancel}
            onSuccess={onSuccess}
          />
        </CContainer>
      </CModalBody>
    </CModal>
  );
};

export default UserChangePasswordModal;
